/* eslint-disable import/prefer-default-export */

export const makeCursorPointer = {
  cursor: 'pointer',
};

export const defaultFieldsValue = {
  email: '',
  type: '',
  date: {
    to: '',
    from: '',
  },
};

export const defaultQueryFilterValue = {
  to: '',
  from: '',
  email: '',
  type: '',
  initiatedBy: '',
};

export const defaultDataValue = {
  note: '',
  uploadedFile: {},
  selectedBox: {},
};
